import { API_ROUTES } from '@/constants/apiRoutes';
import type { AxiosInstance } from 'axios';
import { Commission } from './commissions.types';

export interface CreateCommissionPayload {
  categoryName: string;
  description?: string;
  categoryId?: string;
}

export interface ToggleStatusPayload {
  categoryId: string;
  status: 'A' | 'B';
}

export interface AssignCommissionPayload {
  agentId: string;
  categoryId: string;
}

const createCommission = (client: AxiosInstance) => async (payload: CreateCommissionPayload) => {
  return (
    await client.post<{ message: string; data: CreateCommissionPayload }>(API_ROUTES.CREATE_COMMISSION_CATEGORY, {
      ...payload,
    })
  ).data;
};

const toggleStatusCommission = (client: AxiosInstance) => async (payload: ToggleStatusPayload) => {
  return (
    await client.post<{ message: string; data: Commission }>(API_ROUTES.UPDATE_COMMISSION_CATEGORY_STATUS, {
      categoryId: payload.categoryId,
      status: payload.status,
    })
  ).data;
};

const assignCommission = (client: AxiosInstance) => async (payload: AssignCommissionPayload) => {
  return (
    await client.post<{ message: string; data: AssignCommissionPayload }>(API_ROUTES.ASSIGN_COMMISSION, {
      agentId: payload.agentId,
      categoryId: payload.categoryId,
    })
  ).data;
};

export const commissionsMutations = {
  createCommission,
  toggleStatusCommission,
  assignCommission,
};
